var Comment = React.createClass({
  propTypes: {
    comment: React.PropTypes.object.isRequired,
    onReplySaved: React.PropTypes.func.isRequired,
    showReplyLink: React.PropTypes.bool,
    currentUserID: React.PropTypes.number,
    isResolutionAllowed: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      showReplyLink: false
    }
  },
  getInitialState() {
    return {
      showReplyBox: false
    }
  },
  replyClicked() {
    this.setState({showReplyBox: !this.state.showReplyBox});
  },
  replySaved(comment) {
    this.props.onReplySaved(comment);
    this.setState({showReplyBox: false});
  },
  replyBlock() {
    if (this.props.showReplyLink) {
      let replyLabel = this.state.showReplyBox ? Labels.getLabel("Cancel") : Labels.getLabel("Reply");
      return (
          <div className="comment__actions">
            <a href="#" className="comment__action-link" onClick={this.replyClicked}>{replyLabel}</a>
          </div>
      );
    } else {
      return (<span></span>);
    }
  },
  resolveComment(comment, isResolved) {
    if (isResolved) {
      let data = {
        commentID: comment.id, solutionID: RA.ViewKB.solution.id, SToken: Config.csrf.value
      }
      RAResolveComment.init(data);
    } else {
      let url = Config.contextPath + "/controller/resolveComment/solution/comment/";
      let data = {
        SToken: Config.csrf.value,
        solutionID: RA.ViewKB.solution.id,
        commentID: comment.id,
        isResolved: isResolved
      };

      $.post(url, data)
          .done(r => {
            RA.ViewKB.Comments.load(RA.ViewKB.Comments.currentPage);
          });
    }
  },
  render: function () {
    let comment = this.props.comment;
    let replies = comment.replies.map(r =>
      <Comment key={r.id}
        comment={r}
        showReplyLink={!r.isParentCommentResolved}
        onReplySaved={this.replySaved}/>
    );
    let resolvedComment = comment.resolvedComment,
        replyLink,
        commentBox;

    if (comment.parentID === 0 && resolvedComment != null) {
      if (resolvedComment.resolved) {
        if (this.props.isResolutionAllowed && comment.userID === this.props.currentUserID) {
          replyLink = (
            <div className="comment__actions">
              <a href="#" className="comment__action-link" onClick={() => this.resolveComment(comment, false)}>Unresolve</a>
            </div>
          );
        } else {
          replyLink = (
              <div className="comment__actions"><br/></div>
          );
        }
      } else {
        replyLink = this.replyBlock();
      }
    } else {
      replyLink = this.replyBlock();
    }

    if (this.state.showReplyBox) {
      commentBox = (
        <div className="comment__reply-wrap">
          <CommentBox
            parentID={comment.id}
            buttonLabel={Labels.getLabel("Post Reply")}
            placeholder={Labels.getLabel("Reply to this comment")}
            onCommentSaved={this.replySaved}
            sizeModifier="sm" />
        </div>
      )
    }

    let commentText = comment.comment.replace(/(\r?\n)/g, "<br>$1");
    let profileImagePath = comment.profileImagePath;
    let avatarPath = RA.defaultAvatar(profileImagePath);
    let showAvatar = Boolean(comment.showAvatar);
    let profileText = comment.profileText;

    let resolvedBlock;

    if (comment.parentID === 0 && resolvedComment != null) {
      if (!resolvedComment.resolved) {
        if (this.props.isResolutionAllowed && comment.userID === this.props.currentUserID) {
          resolvedBlock = (
              <a href="#" className="resolve-btn" onClick={() => this.resolveComment(comment, true)}><i
                  className="glyphicon glyphicon-check unresolved-mark-style"></i></a>
          );
        } else {
          resolvedBlock = (<span></span>);
        }
      } else {
        resolvedBlock = (
            <div>
              <i className="glyphicon glyphicon-check resolved-mark-style" title={"Resolved by: " + resolvedComment.resolvedBy}></i>
              <span className="text-success resolved-text">Resolved</span>
            </div>
        );
      }
    } else {
      resolvedBlock = (<span></span>);
    }

    $(window).on('load', function() {
      var url = window.location.href;
      var id = url.substring(url.lastIndexOf('#'));
      if(id !== null && id !== url) {
        var element = $(id);
        if (element.length > 0) {
          $('html, body').animate({
            scrollTop: $(id).offset().top - 150
          }, 'fast');
        }
      }
    });

    const renderProfileImage = () => {
      if (showAvatar && RA.Utils.isNotBlank(profileImagePath)) {
        return (<div className="user-image -sm pull-left">
          <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
          {resolvedBlock}
        </div>)
      } else if (showAvatar && RA.Utils.isNotBlank(profileText)) {
        return (<div className="user-image -sm pull-left">
          <span className="avatar-text-comment user-image__avatar">{profileText}</span>
          {resolvedBlock}
        </div>)
      } else {
        return (<div className="user-image -sm pull-left">
          <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
          {resolvedBlock}
        </div>)
      }
    }

    return (
        <div className="comment">
          {renderProfileImage()}
          <div className="comment__wrap">
            <div className="comment__title">
              <span className="comment__username">{comment.username}</span>
              <time className="comment__time" dateTime={comment.date}> - {comment.friendlyDate}</time>
            </div>
            <div className="comment-href">
              <a href={"#comment" + comment.id}>
                <div id={"comment" + comment.id} className="comment__content">
                  <p dangerouslySetInnerHTML={{__html: commentText}}/>
                </div>
              </a>
            </div>

            {replyLink}

          </div>

          {commentBox}

          {replies}

        </div>
  );
  }
  });